module.exports = new google.maps.StyledMapType([
    {
        'stylers': [
            {
                'saturation': -100
            },
            {
                'gamma': 0.8
            },
            {
                'lightness': 44
            },
            {
                'visibility': 'on'
            }
        ]
    },
    {
        'featureType': 'landscape.natural',
        'stylers': [
            {
                'visibility': 'on'
            },
            {
                'color': '#5dff00'
            },
            {
                'gamma': 4.97
            },
            {
                'lightness': -5
            },
            {
                'saturation': 100
            }
        ]
    }
], {name: 'Styled Map'});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Index/IndexMapStyle.js
// module id = 29
// module chunks = 0